import { Coins } from "lucide-react";

// Approximate USD pricing per second based on Seedance 2.0 public estimates (Magnific resells)
const PRICE_PER_SEC = {
  "seedance-pro-1080p": 0.10,
  "seedance-lite-720p": 0.04,
  "seedance-lite-480p": 0.02,
};

export function estimateCost({ model, durationSec }) {
  const rate = PRICE_PER_SEC[model] ?? 0;
  return rate * durationSec;
}

export function formatUSD(n) {
  if (!n) return "$0.00";
  return `$${n.toFixed(2)}`;
}

/**
 * Tiny inline cost-meter pill. Always visible, never blocking.
 */
export default function CostMeter({ model, durationSec, label = "Est. cost" }) {
  const cost = estimateCost({ model, durationSec });
  return (
    <div
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-amber-500/10 border border-amber-500/20 text-amber-300"
      title={`${label} — Seedance pricing estimate`}
      data-testid="cost-meter"
    >
      <Coins size={11} />
      <span className="text-[10px] font-mono uppercase tracking-wider">
        {formatUSD(cost)}
      </span>
    </div>
  );
}
